// Zorgt ervoor dat het theme object bestaat
window.theme = window.theme || {};

theme.Map = (function() {
  const config = {
    zoom: 14
  };
  let apiStatus = null; // Houdt bij of de Google Maps API geladen is
  const mapQueue = []; // Wachtrij voor kaarten die geladen moeten worden

  const SELECTORS = {
    section: "[data-section-type='map']",
    map: ".js-map"
  };

  // --- API Loader ---
  // Vervangt de oude theme.helpers.loadAsset
  function loadGoogleMapsAPI(apiKey) {
    return new Promise((resolve, reject) => {
      // Als al geladen, stop direct
      if (apiStatus === 'loaded') {
        resolve();
        return;
      }
      
      // Als aan het laden, wacht op 'google-maps-loaded' event
      if (apiStatus === 'loading') {
        document.addEventListener('google-maps-loaded', resolve);
        return;
      }

      apiStatus = 'loading';
      
      // Check of Google Maps al door een ander script is geladen
      if (typeof window.google !== 'undefined' && typeof window.google.maps !== 'undefined') {
        apiStatus = 'loaded';
        document.dispatchEvent(new CustomEvent('google-maps-loaded'));
        resolve();
        return;
      }

      // Maak het script-tag aan en laad de API
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        apiStatus = 'loaded';
        // Verstuur een event zodat andere wachtende scripts het weten
        document.dispatchEvent(new CustomEvent('google-maps-loaded'));
        resolve();
      };
      script.onerror = () => {
        apiStatus = 'error';
        reject();
      };
      document.head.appendChild(script);
    });
  }
  // --- Einde API Loader ---

  // Constructor voor de Kaart
  function Map(container) {
    this.container = container;
    this.mapEl = container.querySelector(SELECTORS.map);
    
    if (!this.mapEl) return;

    const apiKey = this.mapEl.dataset.apiKey;
    if (!apiKey) return;

    // Voeg deze kaart toe aan de wachtrij
    mapQueue.push(this);

    // Probeer de API te laden.
    loadGoogleMapsAPI(apiKey).catch(e => console.error("Failed to load Google Maps API", e));
  }

  // Google's authenticatie-fout afhandelen
  window.gm_authFailure = function() {
    if (!Shopify.designMode) return;
    
    document.querySelectorAll(SELECTORS.section).forEach(section => {
      const map = section.querySelector(SELECTORS.map);
      if (map) {
        map.innerHTML = '<div style="text-align:center; padding: 2rem; background: #f8d7da; color: #721c24;">Google Maps-API-sleutel ongeldig. Controleer de console.</div>';
      }
    });
  };

  Map.prototype = Object.assign({}, Map.prototype, {
    createMap: function() {
      const mapEl = this.mapEl;
      const address = mapEl.dataset.address;

      // 1. Converteer adres naar coördinaten (Geocode)
      return new Promise((resolve, reject) => {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'address': address }, (results, status) => {
          if (status !== 'OK') {
            reject(status);
          } else {
            resolve(results);
          }
        });
      })
      // 2. Maak de kaart aan met de coördinaten
      .then(results => {
        const mapOptions = {
          zoom: config.zoom,
          center: results[0].geometry.location,
          draggable: false,
          clickableIcons: false,
          scrollwheel: false,
          disableDoubleClickZoom: true,
          disableDefaultUI: true
        };

        const map = new google.maps.Map(mapEl, mapOptions);
        const center = map.getCenter();
        new google.maps.Marker({ map: map, position: center });

        // Zorg dat de kaart meeschaalt bij resize
        google.maps.event.addDomListener(window, 'resize', () => {
          google.maps.event.trigger(map, 'resize');
          map.setCenter(center);
          mapEl.removeAttribute('style');
        });
      })
      // 3. Vang fouten op
      .catch(status => {
        console.error(`Geocode was niet succesvol: ${status}`);
        if (Shopify.designMode) {
          mapEl.innerHTML = `<div style="text-align:center; padding: 2rem; background: #fff3cd; color: #856404;">Kon adres niet vinden: ${address}</div>`;
        }
      });
    },

    onUnload: function() {
      // Cleanup
      if (this.mapEl && typeof google !== 'undefined') {
        google.maps.event.clearListeners(this.mapEl, 'resize');
      }
    }
  });

  // --- Wachtrij Verwerker ---
  // Zodra de API geladen is, maak alle kaarten in de wachtrij aan.
  document.addEventListener('google-maps-loaded', () => {
    mapQueue.forEach(instance => instance.createMap());
    // Leeg de wachtrij
    mapQueue.length = 0;
  });

  return Map;
})();

// --- Dawn Sectie Lader ---
// Dit zorgt ervoor dat de kaart werkt met de thema-editor
document.addEventListener('shopify:section:load', function(event) {
  const section = event.target;
  if (section.dataset.sectionType === 'map') {
    new theme.Map(section);
  }
});

// Laad voor secties die al op de pagina staan
document.querySelectorAll("[data-section-type='map']").forEach(section => {
  new theme.Map(section);
});